package navigation.home.request.addeditrequest

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.request.domain.repository.RequestRepository
import com.essntl.features.request.ui.addeditrequest.AddEditRequestEvent
import com.essntl.features.request.ui.addeditrequest.AddEditRequestState
import com.essntl.features.request.ui.addeditrequest.AddEditRequestValidation
import com.essntl.features.request.ui.addeditrequest.AddEditRequestViewModel
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository
import com.essntl.toastmanager.ToastManager

class AddEditRequestScreenModel(
    requestRepository: RequestRepository,
    areaRepository: AreaRepository,
    travelAgentRepository: TravelAgentRepository,
    clientRepository: ClientRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditRequestState>(AddEditRequestState()) {
    val validation = AddEditRequestValidation()

    private val addEditRequestViewModel =
        AddEditRequestViewModel(
            requestRepository = requestRepository,
            areaRepository = areaRepository,
            travelAgentRepository = travelAgentRepository,
            clientRepository = clientRepository,
            toastManager = toastManager,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AddEditRequestEvent) {
        addEditRequestViewModel.onEvent(event)
    }
}
